import styles from './index.module.less';
import { useTranslation } from 'next-i18next';
import Image from 'next/image';

export const PLATFORMS = [
  {
    key: 'ONLYFANS',
    name: 'OnlyFans',
    icon: '/images/erasa/platforms/new/OnlyFans.png',
    url: 'https://www.onlyfans.com/',
  },
  { key: 'TIKTOK', name: 'TikTok', icon: '/images/erasa/platforms/new/TikTok.png', url: 'https://www.tiktok.com/@' },
  { key: 'X', name: 'X', icon: '/images/erasa/platforms/new/X.png', url: 'https://x.com/' },
  {
    key: 'INSTAGRAM',
    name: 'Instagram',
    icon: '/images/erasa/platforms/new/Instagram.png',
    url: 'https://www.instagram.com/',
  },
  { key: 'PATREON', name: 'Patreon', icon: '/images/erasa/platforms/new/Patreon.png', url: 'https://www.patreon.com/' },
  {
    key: 'CHATURBATE',
    name: 'Chaturbate',
    icon: '/images/erasa/platforms/new/Chaturbate.png',
    url: 'https://www.chaturbate.com/',
  },
  { key: 'FANSLY', name: 'Fansly', icon: '/images/erasa/platforms/new/Fansly.png', url: 'https://www.fansly.com/' },
  { key: 'FANVUE', name: 'Fanvue', icon: '/images/erasa/platforms/new/Fanvue.png', url: 'https://www.fanvue.com/' },
  {
    key: 'MANYVIDS',
    name: 'Manyvids',
    icon: '/images/erasa/platforms/new/Manyvids.png',
    url: 'https://www.manyvids.com/',
  },
  { key: 'REDDIT', name: 'Reddit', icon: '/images/erasa/platforms/new/Reddit.png', url: 'https://www.reddit.com/' },
  { key: 'PORNHUB', name: 'Pornhub', icon: '/images/erasa/platforms/new/Pornhub.png', url: 'https://www.pornhub.com/' },
  { key: 'FANSONE', name: 'Fansone', icon: '/images/erasa/platforms/new/Fansone.png', url: 'https://fansone.co/' },
  { key: 'OTHER', name: 'Other', icon: '/images/erasa/platforms/new/Other.png', url: '' },
];

interface Step1Props {
  selectedPlatform: string | null;
  onPlatformSelect: (platformKey: string) => void;
  onClose: () => void;
  /** 文案变体，'shadowban' 时使用检测泄露与假账号的专属文案 */
  copyVariant?: 'default' | 'shadowban';
}

function Step1({ selectedPlatform, onPlatformSelect, onClose, copyVariant = 'default' }: Step1Props) {
  const { t } = useTranslation('common');
  const isShadowban = copyVariant === 'shadowban';

  return (
    <div className={styles.modal}>
      {/* Header */}
      <div className={styles.header}>
        <button className={styles.closeBtn} onClick={onClose} aria-label={t('Close')}>
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M4 4L12 12M12 4L4 12" stroke="#4A5565" strokeWidth="1.33" strokeLinecap="round" />
          </svg>
        </button>
        <div className={styles.headerContent}>
          <h1 className={styles.mainTitle}>
            {isShadowban ? t('Scan for Leaks & Fake Accounts') : t('2 Quick Steps to Get Protected')}
          </h1>
          <div className={styles.stepInfo}>
            <h2 className={styles.title}>
              {isShadowban ? t('Step1: Select Your Platform') : t('Step1: Choose Your Platform')}
            </h2>
            <p className={styles.subtitle}>
              {isShadowban ? t('Choose where your account is active.') : t('Select where you share your content.')}
            </p>
          </div>
        </div>
      </div>

      {/* Platform Grid */}
      <div className={styles.platformGrid}>
        <div className={styles.platformContainer}>
          {PLATFORMS.map((platform) => (
            <button
              key={platform.key}
              className={`${styles.platformBtn} ${selectedPlatform === platform.key ? styles.selected : ''}`}
              onClick={() => onPlatformSelect(platform.key)}
            >
              <div className={styles.platformIcon}>
                <Image src={platform.icon} alt={platform.name} width={32} height={32} />
              </div>
              <span className={styles.platformName}>{platform.name}</span>
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}

export default Step1;
